import { SelectStage, SelectWorkspace, StageSelect, WorkspaceSelect } from "./SelectBox";

import { Button } from "react-migration/components/Button";
import clsx from "clsx";
import { useContextMenuClose } from "react-migration/components/ContextMenu";

type WorkspaceFieldProps = {
  label: string;
  workspaces: SelectWorkspace[];
  selectedWorkspace?: SelectWorkspace;
  onChange: (workspace: SelectWorkspace | undefined) => void;
  loading?: boolean;
};

type StageFieldProps = {
  label: string;
  stages: SelectStage[];
  selectedStage?: SelectStage;
  onChange: (stage: SelectStage | undefined) => void;
  loading?: boolean;
};

type MoveToStageFormProps = {
  title: string;
  description?: string;
  cancelLabel: string;
  submitLabel: string;
  workspaceSelect?: WorkspaceFieldProps;
  stageSelect?: StageFieldProps;
  disabled?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

export const MoveToStageForm = ({
  title,
  description,
  cancelLabel,
  submitLabel,
  workspaceSelect,
  stageSelect,
  disabled = false,
  onSubmit,
  onCancel,
}: MoveToStageFormProps) => {
  const closeContextMenu = useContextMenuClose();

  const handleCancel = () => {
    closeContextMenu();
    onCancel();
  };

  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "items-start",
        "justify-center",
        "gap-3",
        "space-x-4",
        "md:w-70",
        "p-3",
        "z-51"
      )}
    >
      <div className={clsx("flex", "flex-col", "gap-0")}>
        <p className={clsx("text-sm", "font-medium", "text-dark", "m-0!")}>{title}</p>
        {description && <p className={clsx("text-xs", "text-blue-grey-600a", "m-0!")}>{description}</p>}
      </div>
      <div className={clsx("flex", "flex-col", "gap-3", "w-full")}>
        {workspaceSelect && (
          <div
            className={clsx("flex", "flex-col", "overflow-hidden", "gap-y-1.5", "grow")}
            data-testid="workspace-select"
          >
            <p className={clsx("text-sm", "text-blue-gray-600", "m-0!")}>{workspaceSelect.label}</p>
            <WorkspaceSelect
              selectedWorkspace={workspaceSelect.selectedWorkspace}
              onChange={workspaceSelect.onChange}
              workspaces={workspaceSelect.workspaces}
              loading={workspaceSelect.loading ?? false}
            />
          </div>
        )}
        {stageSelect && (
          <div className={clsx("flex", "flex-col", "overflow-hidden", "gap-y-1.5", "grow")} data-testid="stage-select">
            <p className={clsx("text-sm", "text-gray-600", "m-0!")}>{stageSelect.label}</p>
            <StageSelect
              selectedStage={stageSelect.selectedStage}
              onChange={stageSelect.onChange}
              stages={stageSelect.stages}
              loading={stageSelect.loading ?? false}
            />
          </div>
        )}
        <div className={clsx("flex", "justify-end", "gap-2")}>
          <Button onClick={handleCancel} variant="ghost">
            {cancelLabel}
          </Button>
          <Button onClick={onSubmit} variant="primary" disabled={disabled}>
            {submitLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
